import {BehaviorSubject} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {mc} from '@/core';
import {userApi} from '@/api/user';
import {isLogin$} from '@/streams/auth';

export const contractBiz$ = new BehaviorSubject([]);

isLogin$
  .pipe(
    filter(Boolean),
    map(() => getCustomize())
  )
  .subscribe();

async function getCustomize() {
  const {data, error} = await userApi.getCustomizeBiz();
  if (data) {
    contractBiz$.next(data);
  }
  if (error) {
    mc.send('toast', 'error', error);
  }
}

export async function updateCustomize({bizKey, curVersion, settings}) {
  const version = curVersion + 1;
  const params = {bizVal: JSON.stringify(settings), bizKey, version};
  const {data, error} = await userApi.updateCustomizeBiz(params);
  if (data) {
    return version;
  }
  if (error) {
    mc.send('toast', 'error', error);
  }
  return -1;
}
